import React, { memo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../../features/auth/authLoginSlice";
import { useIdleTimer } from "react-idle-timer";
import { useTranslation } from "react-i18next";

const IdleTimerContainer = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const sessionTimeoutRef = useRef(null);

  const onIdle = () => {
    setIsDialogOpen(true);
    sessionTimeoutRef.current = setTimeout(onConfirm, 1000 * 60 * 1); //if user does not responds to modal then logout in one minute
  };

  const onConfirm = () => {
    dispatch(logoutUser());
    setIsDialogOpen(false);
    clearTimeout(sessionTimeoutRef.current);
  };

  const keepLogin = () => {
    setIsDialogOpen(false);
    clearTimeout(sessionTimeoutRef.current);
  };

  useIdleTimer({
    timeout: 1000 * 60 * 30, //30 mins
    onIdle: onIdle,
    debounce: 500,
  });

  return (
    <div>
      {isDialogOpen && (
        <dialog
          id="delete_dialog2"
          className="bottom-0 fixed flex h-full inset-x-0 px-4 sm:inset-0 sm:items-center sm:justify-center w-full z-40"
          open
        >
          <span
            className="!w-[483px] bg-white overflow-hidden pl-[50px] pr-[25px] pt-[52px] py-[48px] relative rounded"
            style={{ boxShadow: "0 4px 14px #0003" }}
          >
            <span className="!font-[400] font-open-sans text-base text-gray-800 text-left">
              <p className="max-w-[380px]">{t("loggedOutSoon")}</p>
              <span className="flex gap-[28px] items-end justify-end mt-[32px]">
                <button
                  id="close-button"
                  tabIndex="0"
                  className="!btn__tertiary !flex !items-center !justify-center !py-[9px] !text-secondary-red"
                  aria-label="Close"
                  type="button"
                  onClick={() => keepLogin()}
                >
                  {t("KeepMeloggedIn")}
                </button>
                <button
                  id="delete-button"
                  tabIndex="0"
                  className="!bg-primary-yellow !btn__primary !flex !h-[40px] !hover:bg-primary-yellow-100 !items-center !justify-center !px-[16px] !text-black !w-fit"
                  aria-label="Close"
                  type="button"
                  onClick={() => onConfirm()}
                >
                  {t("Logout")}
                </button>
              </span>
            </span>
          </span>
        </dialog>
      )}
    </div>
  );
};

export default memo(IdleTimerContainer);
